import React from 'react';
import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledTitle = styled(Typography)(() => ({
    fontWeight: 'bold',
    paddingBottom: '10px',
}));
export const QuotationDetailsDataItem: React.FC<{
    children: React.ReactNode;
    title: string;
}> = (props) => {
    const { title, children } = props;

    return (
        <div>
            <div>
                <StyledTitle>{title}</StyledTitle>
            </div>
            <div>{children}</div>
        </div>
    );
};
